import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const CompanyPhilosophyContent = (props) => {
  const {data} = props;
  return (
    <>
      <div>
        {data && data.length
          ? data.map((item, index) => (
              <div className="philosophy-block" key={index}>
                <div className="row">
                  <div className={`${index === 0 || index % 2 === 0 ? 'offset-lg-2' : ''} col-lg-10 col-12`}>
                    <div className="company-philosophy">
                      <img
                        src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                        className="w-100 h-100 philosophy-block-image"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className={`${index === 0 || index % 2 === 0 ? '' : 'offset-lg-6'} col-lg-6 col-12`}>
                    <div className="company-philosophy-text">
                      <div className="company-philosophy-title jp-bold-600">{item.title}</div>
                      <hr className="company-philosophy-line" />
                      <div className="company-philosophy-content jp-font-sawarabi-gothic">{item.content}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : ''}
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyPhilosophyContent);
